import React, { useState } from 'react';
import { Header } from './components/Header';
import { Sidebar } from './components/Sidebar';
import { Footer } from './components/Footer';
import { ProtocolDetail } from './components/ProtocolDetail';
import { Overview, Technique, AboutJin } from './components/StaticContent';
import { Protocol } from './data/protocols';
type View = 'overview' | 'technique' | 'about' | 'protocol';
export function App() {
  const [currentView, setCurrentView] = useState<View>('overview');
  const [selectedProtocol, setSelectedProtocol] = useState<Protocol | null>(null);
  const [searchQuery, setSearchQuery] = useState('');
  const handleNavigate = (view: string) => {
    if (view === 'overview' || view === 'technique' || view === 'about') {
      setCurrentView(view);
      setSelectedProtocol(null);
    }
  };
  const handleSelectProtocol = (protocol: Protocol) => {
    setSelectedProtocol(protocol);
    setCurrentView('protocol');
    // On mobile, you might want to scroll to top or close sidebar here
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  const renderContent = () => {
    switch (currentView) {
      case 'overview':
        return <Overview data-id="element-0" />;
      case 'technique':
        return <Technique data-id="element-1" />;
      case 'about':
        return <AboutJin data-id="element-2" />;
      case 'protocol':
        return selectedProtocol ? <ProtocolDetail protocol={selectedProtocol} data-id="element-3" /> : <Overview data-id="element-4" />;
      default:
        return <Overview data-id="element-5" />;
    }
  };
  return <div className="min-h-screen bg-[#FAF8F6] flex flex-col font-sans text-[#1F1F1F]" data-id="element-6">
      <Header onNavigate={handleNavigate} data-id="element-7" />

      <main className="flex flex-col md:flex-row flex-1 max-w-[1600px] mx-auto w-full" data-id="element-8">
        <Sidebar activeProtocolId={selectedProtocol?.id || null} onSelectProtocol={handleSelectProtocol} searchQuery={searchQuery} onSearchChange={setSearchQuery} data-id="element-9" />

        <section className="flex-1 p-4 md:p-6 overflow-y-auto h-full" data-id="element-10">
          <div className="max-w-4xl mx-auto" data-id="element-11">{renderContent()}</div>
        </section>
      </main>

      <Footer data-id="element-12" />
    </div>;
}